import { toast, ToastOptions } from "react-toastify";

import { TOAST_DEFAULT_AUTO_CLOSE_TIME } from "../../configs/toast";

import styles from "./CustomToast.module.scss";

export const showCustomToast = (message: string, options?: ToastOptions) => {
  return toast(message, {
    className: styles.customToast,
    bodyClassName: styles.customToastBody,
    closeButton: true,
    autoClose: TOAST_DEFAULT_AUTO_CLOSE_TIME,
    position: "top-center",
    ...options,
  });
};
